
import { extendTheme } from '@chakra-ui/react'

const chakraTheme = extendTheme({
  fonts: {
    heading: `'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'Inter', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
  },
})

export default chakraTheme
